export const SCIENTIFIC_NAME_DOC_TYPES = [
  { key: "overview", fallbackTitle: "Overview" },
  { key: "diagnosis", fallbackTitle: "Diagnosis" },
  { key: "differential_diagnosis", fallbackTitle: "Differential Diagnosis" },
];

export const DEFAULT_DOC_LANG = "ja";
